import { Profession } from './enums/profession';

export const careProviderProfessions = [
    Profession.generalPractitioner,
    Profession.generalPractitionerHidha,
    Profession.generalPractitionerMentalHealthSpecialist,
    Profession.generalPractitionerWaarnemer,
];
